import { useAppSelector } from '@redux/store';

// Chức vụ "Người dùng phổ thông, phụ huynh" (enum/combobox.ts, id KH-PHOTHONG — tách theo
// docx §4). User đăng nhập là phụ huynh khi jobTitle của họ (userInfo.title) = mã này.
export const JOB_TITLE_PHU_HUYNH = 'KH-PHOTHONG';

/** True nếu user đang đăng nhập là phụ huynh (nhận diện theo chức vụ mới, không theo tên/role). */
const useIsParent = (): boolean =>
  useAppSelector((s) => s.auth.userInfo?.title) === JOB_TITLE_PHU_HUYNH;

export default useIsParent;
